import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const getUserProfileKitsCreated = async ({ uid, limit }) => {
	try {
		const userProfileDocRef = firestore.collection('userProfiles').doc(uid)
		const query = userProfileDocRef.collection('kitsCreated').orderBy('modifiedTimestamp', 'desc')
		const kitsCreatedQuerySnap = await (limit ? query.limit(limit) : query).get()
		const kitsCreated = kitsCreatedQuerySnap.docs.map(d => d.data())
		return kitsCreated
	} catch (error) {
		throw errorOfType(errorTypes.UNKNOWNERROR, uid, error)
	}
}

export default getUserProfileKitsCreated



// WEBPACK FOOTER //
// ./src/dataservices/getUserProfileKitsCreatedByModifiedTimestamp.js